import { OdataFilters, queryCollection } from "helpers/reqparams";
import { request } from "services/request";

const resource = "api/logs";

const notificationQuery = { orderBy: ["id desc"] };

const index = ({ preparedFilter, trackerId, ...params }: OdataFilters & { trackerId: number }) => {
    const query = queryCollection(params, { filter: preparedFilter, ...notificationQuery });
    return request(`${resource}/getNotificationQueue${query}`, { method: "GET" }, { countInHeaders: true });
};

const getItem = ({ id }: { id: number }) => request(`${resource}/getNotificationContent/${id}`, { method: "GET" });

export { index, getItem };
